import { Providers } from "@/app/providers";
import { AppRouter } from "@/app/router";

export default function App(): JSX.Element {
  return (
    <Providers>
      <AppRouter />
    </Providers>
  );
}
